import React, { useEffect, useState } from "react";

const ResponsiveFilterSection = ({
  title,
  children,
  defaultOpen = false,
  active = false,
  posthogId = "filter-section-toggle",
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen || active);

  useEffect(() => {
    if (active) setIsOpen(true);
  }, [active]);

  return (
    <section className="responsive-filter-section">
      <button
        type="button"
        className="responsive-filter-section-toggle visible-on-mobile"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((value) => !value)}
        data-posthog={posthogId}
        data-posthog-filter-section={title}
      >
        <span>{title}</span>
        <span aria-hidden="true">{isOpen ? "−" : "+"}</span>
      </button>
      <div
        className={`responsive-filter-section-content ${
          isOpen ? "" : "responsive-filter-section-content-collapsed"
        }`.trim()}
      >
        {children}
      </div>
    </section>
  );
};

export default ResponsiveFilterSection;
